import createIcon from '../../createIcon';

/**
 * @component @name FormatTextdirectionLToR
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAxMFYxNUgxMFY0SDEyVjE1SDE0VjRIMTZWMkg4QzUuNzkgMiA0IDMuNzkgNCA2QzQgOC4yMSA1Ljc5IDEwIDggMTBaTTIwIDE4TDE2IDE0VjE3SDRWMTlIMTZWMjJMMjAgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatTextdirectionLToR = createIcon('FormatTextdirectionLToR', [
  [
    'path',
    {
      d: 'M8 10V15H10V4H12V15H14V4H16V2H8C5.79 2 4 3.79 4 6C4 8.21 5.79 10 8 10ZM20 18L16 14V17H4V19H16V22L20 18Z',
      key: 'fjozy',
    },
  ],
]);

export default FormatTextdirectionLToR;
